import _ from 'lodash';
import React from 'react';
import {loadingTextsFor} from './utils';
import {useScoringRun} from '../../../context/ScoringRunContext';
import {useScoringSignalResolver} from '../../../hooks/scoringSignal';
import {ScoringSignal} from '../../../shared/signals';
import {filterNull} from '../../../shared/util';
import {useAccountQueryParams} from '../gridStore';
import {useSignalCounts} from '../useSignalCounts';
import {FilterSelect} from './FilterSelect';
import {FilterControlWithNegate} from './FilterControlWithNegate';

const ScoringSignalFilterLoadingTexts = loadingTextsFor('signals');

export const ScoringSignalsFilterControl = ({
  value,
  negate,
  onChange,
  onRemove,
}: {
  value: ScoringSignal[];
  negate?: boolean;
  onChange: (value: ScoringSignal[], negate?: boolean) => void;
  onRemove: () => void;
}) => {
  const scoringRun = useScoringRun();
  const queryParams = useAccountQueryParams(scoringRun._id);
  const signalCounts = useSignalCounts({
    queryParams,
    enabled: true,
  });
  const scoringSignalResolver = useScoringSignalResolver();

  const selectedSignalOptions = React.useMemo(
    () =>
      filterNull(
        value.map((signal) => {
          const signalDetails = scoringSignalResolver(signal);
          if (!signalDetails) {
            return null;
          }

          return {
            value: signalDetails.id,
            label: signalDetails.label,
          };
        })
      ),
    [scoringSignalResolver, value]
  );

  let signalOptions: Array<{value: ScoringSignal; label: string}> = [];
  if (signalCounts.status === 'success') {
    signalOptions = filterNull(
      _.map(signalCounts.data, (count, signal) => {
        const signalDetails = scoringSignalResolver(signal);
        if (!signalDetails) {
          return null;
        }

        return {
          value: signalDetails.id,
          label: count
            ? `${signalDetails.label} (${count})`
            : signalDetails.label,
        };
      })
    );
  }

  return (
    <FilterControlWithNegate
      value={value}
      negate={negate}
      onChange={onChange}
      onRemove={onRemove}
    >
      {(_, onValueChange) => (
        <FilterSelect
          isMulti
          options={signalOptions}
          onChange={(values) => {
            onValueChange(values.map((v) => v.value));
          }}
          value={selectedSignalOptions}
          noOptionsMessage={() =>
            ScoringSignalFilterLoadingTexts[signalCounts.status]
          }
        />
      )}
    </FilterControlWithNegate>
  );
};
